import axios from 'src/app-axios';
import Constants from 'src/constants';
export const company = {
    namespaced: true,
    state: {
        appUsersCompanies: [],
    },
    getters: {
        getAppUsersCompanies (state) {
            return state.appUsersCompanies;
        },
    },
    mutations: {
        setAppUsersCompaniesList (state, data) {
            state.appUsersCompanies = data;
        },
    },
    actions: {
        async fetchAppUsersCompanies ({ dispatch, commit }, payload) {
            const url = `api/devices/organizations/${payload.organizationId}/companies`;
            try {
                const companies = await axios.get(url);
                commit('setAppUsersCompaniesList', companies.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting the app users companies list.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
    },
  };
